import { render, staticRenderFns } from "./fullFift.vue?vue&type=template&id=9acf2c32&scoped=true&"
import script from "./fullFift.vue?vue&type=script&lang=js&"
export * from "./fullFift.vue?vue&type=script&lang=js&"
import style0 from "./fullFift.vue?vue&type=style&index=0&id=9acf2c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acf2c32",
  null
  
)

export default component.exports